import { Skeleton } from "@/components/ui/skeleton";

export const DrawingCardSkeleton = () => {
  return (
    <div className="absolute inset-0 bg-background/50">
      <div className="w-full h-full flex items-center justify-center">
        <Skeleton className="w-full h-full" />
      </div>
    </div>
  );
};